<template>

    <div class="tabs__wrapper">
        <ul class="portal-h-tabs" id="orders_tabs">
            <li class="access-tab tab-trigger" :class="{selected: this.tab_selected === 0}"
                @click="selectTab(0)">
                <a>
                    <p class="subheadline no-margins">
                        {{ trans('distrib.orders.req') }}
                    </p>
                </a>
            </li>
            <li class="access-tab tab-trigger" :class="{selected: this.tab_selected === 1}"
                @click="selectTab(1)">
                <a>
                    <p class="subheadline no-margins">
                        {{ trans('distrib.orders.ord') }}
                    </p>
                </a>
            </li>
        </ul>
        <div class="tabs-content-panel">
            <div>
                <div class="tab-catcher" v-if="this.tab_selected === 0">
                    <div class="view__table">
                        <request-table :requests="myfastcheckouts" />
                    </div>
                </div>
                <div class="tab-catcher" v-if="this.tab_selected === 1">
                    <div class="view__table">
                        <invoice-table :orders="myorders" :is_biome="is_biome" :is_distributor="is_distributor" />
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

export default {

    props: {
        fastcheckouts: {},
        orders: {},
        becrop_types: {},
        active_tab: {},
        is_biome: {},
        is_distributor: {}, // Is the current client a distributor
    },

    data() {
        // Table 1: fastcheckouts & shipments
        const myfastcheckouts = this.createFastcheckoutTable();

        // Table 2: orders & invoices
        const myorders = this.createOrdersTable();

        return {
            // myTables,
            myfastcheckouts,
            myorders,
            tab_selected: this.active_tab
        };
    },

    methods: {

        selectTab(i) {
            this.tab_selected = i;
        },

        createFastcheckoutTable() {
            return {
                type: 'requests',
                name: trans('distrib.orders.req'),
                items: this.fastcheckouts.map(this.formatFastcheckoutItem),
            };
        }, // createFastcheckoutTable

        formatFastcheckoutItem(dbfastcheckout) {
            let status = 'pending';
            if (!dbfastcheckout.pending) {
                if (!dbfastcheckout.accepted) {
                    status = 'discarded';
                } else {
                    status = 'accepted';
                }
            }

            const id = '#fco-' + dbfastcheckout.id +
                    (dbfastcheckout.shipment_id
                        ? '/#shp-' + dbfastcheckout.shipment_id
                        : '');

            const name = dbfastcheckout.shipment
                ? dbfastcheckout.shipment.name
                : 'No name because it\'s a fast-checkout';

            let agent = null;
            if (dbfastcheckout.shipment && dbfastcheckout.shipment.owner) {
                agent = dbfastcheckout.shipment.owner;
            }

            return {
                id,
                name,
                created_at: dbfastcheckout.created_at,
                num_items: dbfastcheckout.bulks.reduce((acc, bulk) => acc + bulk.num, 0),
                status,
                agent: agent,
                bulks: dbfastcheckout.bulks.map(this.formatBulk),
                // bulk_text: dbfastcheckout.bulks.reduce((acc,bulk) => acc + " " + bulk.name + ' x ' + bulk.num, ''),
                final_client: this.formatClient(dbfastcheckout.final_client),
            };
        }, // formatFastcheckoutItem

        createOrdersTable() {
            return {
                type: 'orders',
                name: trans('distrib.orders.inv'),
                items: this.orders.map(this.formatOrderItem),
            };
        }, // createOrdersTable

        formatOrderItem(dborder) {
            let dbfastcheckout = null;
            const dbshipment = dborder.shipment;
            if (dbshipment) dbfastcheckout = dbshipment.fastcheckout;

            let ref = [];
            if (dbfastcheckout) ref.push('#fco-' + dbfastcheckout.id);
            if (dbshipment) ref.push('#shp-' + dbshipment.id);
            ref = ref.join('/');

            let invoice = this.formatInvoice(dborder.invoice);
            let is_fake_invoice = false;
            if (!invoice) {
                invoice = this.formatFakeInvoice(dborder.fake_invoice);
                is_fake_invoice = true;
            }

            return {
                ref,
                order_id: dborder.id,
                bpo_id: dborder.bpo_id,
                final_client: this.formatClient(dborder.final_client),

                created_at: dborder.created_at,

                invoice,
                is_fake_invoice,
            };
        }, // formatOrderItem

        formatInvoice(dbinvoice) {
            if (!dbinvoice) return null;

            const payload = JSON.parse(dbinvoice.payload);

            let total_items = 0;
            payload.items.forEach(item => {
                if (!item.num) return;
                total_items += item.num;
            });

            let download_link = null;
            if (dbinvoice.number) {
                download_link = '/orders/invoice/' + dbinvoice.number.replace(/\//g, '-');
            }

            return {
                number: dbinvoice.number,
                creation_date: payload.meta.creation_date,
                due_date: payload.meta.due_date,
                due_amount: payload.amount.final_price,
                currency: payload.meta.currency,
                paid: dbinvoice.paid,
                items: payload.items,
                total_items,
                download_link,
            };
        },

        formatFakeInvoice(fakedbinvoice) {
            let total_items = 0;
            fakedbinvoice.forEach(item => {
                total_items += item.num;
            });

            return {
                number: null,
                creation_date: null,
                due_date: null,
                due_amount: null,
                currency: null,
                paid: null,
                items: fakedbinvoice,
                total_items,
                download_link: null,
            };
        },

        formatClient(dbclient) {
            if (!dbclient) return null;
            return {
                name: dbclient.nombre_comercial,
                code: dbclient.c_wineseq,
                pic: `/client.pic/${dbclient.id ? dbclient.id : 0}/photo.jpg?square=true`
            };
        },

        getType(type_id) {
            let found = this.becrop_types.find(type => type.type_id === type_id);
            if (!found) found = this.becrop_types[0];

            return found;
        },

        formatBulk(dbbulk) {
            const becrop_type = this.getType(dbbulk.type_id);

            return {
                name: becrop_type.name,
                logo_name: becrop_type.logo_name,
                num: dbbulk.num,
                img: becrop_type.icon2,
            };
        },

    }

};

</script>
